import React, {memo, useEffect} from "react";
import PropTypes from "prop-types";
import {Box, ListItem, Typography} from "@mui/material";
import {Link} from "react-router-dom";
import {useRegScoutCore} from "../../resources/RegScoutCoreProvider";
import {useTheme} from "../../resources/ConsolidatedThemeProvider";
import {formatResponse} from "./chatbotHelpers";
import {isEmpty, map} from "underscore";
import {useChatbotMessageStyles} from "./chatbotStyles";

const ChatbotMessage = ({message, messageListRef, isStreaming}) => {
  const {isPlatform} = useRegScoutCore();
  const {activeTheme} = useTheme();
  const isDarkTheme = activeTheme.palette.mode === "dark";
  const isHuman = message.sender === "user";
  const {classes} = useChatbotMessageStyles({isHuman});

  const formattedMessage = formatResponse(message.text || "", isDarkTheme, isStreaming);

  useEffect(() => {
    if (!messageListRef.current) {
      return;
    }
    messageListRef.current.scrollTop = messageListRef.current.scrollHeight;
  }, [message.text]);

  return (
    <ListItem alignItems="flex-start" className={classes.chatbotMessageItem}>
      <Box className={classes.chatbotMessageWrapper}>
        <Box
          dangerouslySetInnerHTML={{__html: formattedMessage}}
          className={`${classes.chatbotMessage} ${classes.chatbotMessageText}`}
        />
        {!isEmpty(message?.references) ?
          (
            <Typography
              variant="overline"
              display="block"
              lineHeight={1.5}
              marginTop={2}
              className={classes.chatbotMessageText}
            >
              Learn More:
            </Typography>
          ) :
          null}
        {!isEmpty(message?.references) ?
          (
            <ul style={{listStyleType: "none", padding: 0}}>
              {map(message?.references, (reference, index) => (
                <li key={index}>
                  <Link
                    to={
                      isPlatform ?
                        `/compliance/research/regulation/${reference.id}` :
                        `/regulation/${reference.id}`
                    }
                    className={classes.chatbotMessageText}
                    id="reference-link"
                  >
                    <Typography
                      variant="caption"
                      className={classes.chatbotMessageText}
                    >
                      {reference.jurisdiction || `${index}`}
                    </Typography>
                  </Link>
                </li>
              ))}
            </ul>
          ) :
          null}
      </Box>
    </ListItem>
  );
};

ChatbotMessage.propTypes = {
  message: PropTypes.object,
  messageListRef: PropTypes.object,
  isStreaming: PropTypes.bool,
};

export default memo(ChatbotMessage);
